import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";

import { openUserAction } from "../../../../../../services/UserActionConfirm/actions";
import CommandsWrapper from "../../../../templates/CommandsWrapper";
import TemplatesFooter from "../../../../components/TemplatesFooter";
import useFooterActions from "../hooks/useFooterActions";

import CreateTemplateDialog from "./CreateTemplateDialog";
import TemplateSelectors from "./TemplateSelectors";
import UpdateTemplateSelectorDialog from "./UpdateTemplateSelectorDialog";
import useTemplateSelectorDialog from "./hooks/useTemplateSelectorDialog";
import TemplatesHeader from "./TemplatesHeader";

import styles from "./styles.module.scss";


const Templates = ({
    currentIframeRef,
    currentIframeWrapperRef,
    getPathTo,
    templatesData,
    getElementsByText,
    clearCssClassName,
    highlightElement
}) => {
    const dispatch = useDispatch();
    const {
        options,
        templatesList,
        currentTemplate,
        onChangeTemplate,
        isOpenUpdateDialog,
        onOpenUpdateDialog,
        onCloseUpdateDialog,
        onCreateTemplate,
        onUpdateTemplateSelector,
        onDeleteTemplateSelector
    } = templatesData;

    const [ initialValuesSelectorDialog, setInitialValuesSelectorDialog ] = useState(undefined);

    const templateSelectors = currentTemplate?.template_selectors;

    const {
        isOpenTemplateSelectorDialog,
        onOpenTemplateSelectorDialog,
        onCloseTemplateSelectorDialog
    } = useTemplateSelectorDialog();

    const handleOpenUpdateSelectorDialog = useCallback(
        (indexSelector) => {
            const currentSelector = templateSelectors.reduce(
                (acc, item, index) => {
                    if(index === indexSelector) {
                        return { index: index, ...item };
                    }

                    return acc;
                },
                {}
            );

            setInitialValuesSelectorDialog(currentSelector);
            onOpenTemplateSelectorDialog();
        },
        [ onOpenTemplateSelectorDialog, templateSelectors ]
    );

    const handleUpdateTemplateSelector = useCallback(
        ({ index, ...values }) => {
            const newTemplateSelectorsList = templateSelectors.map((selector, itemIndex) => {
                if(index === itemIndex) {
                    return values;
                }

                return selector;
            });

            onUpdateTemplateSelector(newTemplateSelectorsList);
            onCloseTemplateSelectorDialog();
        },
        [ onCloseTemplateSelectorDialog, onUpdateTemplateSelector, templateSelectors ]
    );

    const handleDeleteTemplateSelector = useCallback(
        (indexSelector) => {
            dispatch(openUserAction({
                actionType: "remove Template Selector",
                action: () => onDeleteTemplateSelector(indexSelector)
            }));
        },
        [ dispatch, onDeleteTemplateSelector ]
    );


    const {
        handleClickPrevState,
        handleClickNextState,
        handleClickSave
    } = useFooterActions(templatesList, currentTemplate);

    return (
        <>
            <CommandsWrapper
                header={(
                    <TemplatesHeader
                        title="Template"
                        commandClassName={styles.headerCommands}
                        selectProps={{
                            options,
                            value: currentTemplate?.code,
                            onChange: onChangeTemplate
                        }}
                        onOpenUpdateDialog={onOpenUpdateDialog}
                    />
                )}
                body={(
                    <TemplateSelectors
                        currentIframeRef={currentIframeRef}
                        currentIframeWrapperRef={currentIframeWrapperRef}
                        templateSelectors={templateSelectors}
                        onEditTemplateSelector={handleOpenUpdateSelectorDialog}
                        onDeleteTemplateSelector={handleDeleteTemplateSelector}
                        getPathTo={getPathTo}
                        getElementsByText={getElementsByText}
                        highlightElement={highlightElement}
                        clearCssClassName={clearCssClassName}
                    />
                )}
                footer={(
                    <TemplatesFooter
                        onClickPrevState={handleClickPrevState}
                        onSave={handleClickSave}
                        onClickNextState={handleClickNextState}
                    />
                )}
            />

            <CreateTemplateDialog
                isOpen={isOpenUpdateDialog}
                onClose={onCloseUpdateDialog}
                onSubmitFormDialog={onCreateTemplate}
            />

            <UpdateTemplateSelectorDialog
                isOpen={isOpenTemplateSelectorDialog}
                initialValues={initialValuesSelectorDialog}
                onClose={onCloseTemplateSelectorDialog}
                onSubmitFormDialog={handleUpdateTemplateSelector}
            />
        </>
    );
};

export default Templates;
